import styled from "styled-components";
import colors from "../../../../../../config/colors";
import { panelSpacing } from "../../../../../../common/styles";

export const AnnouncementsContainer = styled.div``;

export const AnnouncementHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Announcer = styled.div`
  display: flex;
  align-items: center;
`;
export const AnnouncerImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #4f449b;
`;
export const AnnouncementInfo = styled.div`
  margin-left: 10px;
`;
export const AnnouncerName = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
export const AnnouncementTime = styled.div`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;
export const AnnouncementEdit = styled.div`
  margin-left: 20px;
`;
export const AnnouncementContent = styled.div`
  word-break: break-word;
`;

export const ViewMoreSpan = styled.span`
  cursor: pointer;
  color: ${colors.primary};
`;

export const NoAnnouncementContainer = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
`;
export const NoAnnouncementInner = styled.div`
  padding: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 26vh;
`;
export const NoAnnouncementImage = styled.img``;
export const NoAnnouncementText = styled.p`
  color: #302f2f;
  text-align: center;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 10px 0 0;
`;

export const ProgramImage = styled.img`
  width: 250px;
  height: 200px;
  margin-top: 12px;
  margin-right: 20px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid ${colors.backgroundGrey};
  @media (max-width: 1200px) {
    width: 160px;
    height: 160px;
  }
`;
